export const PRODUCTTAG_LOADING = "PRODUCTTAG_LOADING";
export const GET_PRODUCTTAG = "GET_PRODUCTTAG";
export const GET_PRODUCTTAG_SUCCESS = "GET_PRODUCTTAG_SUCCESS";
export const GET_PRODUCTTAG_FAIL = "GET_PRODUCTTAG_FAIL";
export const DELETE_PRODUCTTAG = "DELETE_PRODUCTTAG"
export const DELETE_PRODUCTTAG_SUCCESS = "DELETE_PRODUCTTAG_SUCCESS"
export const DELETE_PRODUCTTAG_FAIL = "DELETE_PRODUCTTAG_FAIL"
export const UPDATE_PRODUCTTAG = "UPDATE_PRODUCTTAG"
export const UPDATE_PRODUCTTAG_SUCCESS = "UPDATE_PRODUCTTAG_SUCCESS"
export const UPDATE_PRODUCTTAG_FAIL = "UPDATE_PRODUCTTAG_FAIL"
export const ADD_NEW_PRODUCTTAG = "ADD_NEW_PRODUCTTAG"
export const ADD_PRODUCTTAG_SUCCESS = "ADD_PRODUCTTAG_SUCCESS"
export const ADD_PRODUCTTAG_FAIL = "ADD_PRODUCTTAG_FAIL"